import { z } from 'zod'
import { addressSchema, stringSchema } from './common'

export const userSchema = z.object({
  id: stringSchema.min(1),
  firstName: stringSchema.min(1),
  lastName: stringSchema.min(1),
  emailAddress: stringSchema.min(1),
  phoneNumber: stringSchema.nullish(),
  address: addressSchema.nullish(),
})
